function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, Descriptions, Divider, Alert } from 'antd';
import { Eyedropper } from "react-bootstrap-icons";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var NewSample = function NewSample(_ref) {
  var customer = _ref.customer,
    items = _ref.items,
    queueId = _ref.queueId,
    handler = _ref.handler;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    itemsOptions = _useState2[0],
    setItemsOptions = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormProcessing = _useState4[0],
    setIsFormProcessing = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    successMessage = _useState8[0],
    setSuccessMessage = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    sample = _useState10[0],
    setSample = _useState10[1];
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append('service_id', values.service_id);
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", customer.id);
    formData.append("queue_id", queueId);
    axios.post(Common.baseApiUrl + "setsampleid", formData).then(function (response) {
      if (response.data.status == 200) {
        setSample(response.data.sample);
        setSuccessMessage("Echantillon créé avec succès");
      } else {
        setErrorMessage(response.data.message);
      }
      handler();
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    var tar = Array();
    items.forEach(function (e) {
      if (!tar.includes(e.medical_item.service.id)) {
        setItemsOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: e.medical_item.service.label,
            value: e.medical_item.service.id
          }]);
        });
        tar.push(e.medical_item.service.id);
      }
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Descriptions, {
      size: "small",
      bordered: true,
      column: 1,
      children: [/*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Pr\xE9nom",
        children: customer.firstname
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Nom",
        children: customer.lastname
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "T\xE9l\xE9phone",
        children: customer.mobile.slice(3)
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), successMessage.length > 0 && sample != null && /*#__PURE__*/_jsxs("h2", {
      children: ["N.ECHANT. ", sample.sampleid]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "service_id",
        label: "Choisir une cat\xE9gorie",
        children: /*#__PURE__*/_jsx(Select, {
          showSearch: true,
          options: itemsOptions
        })
      }), /*#__PURE__*/_jsxs(Form.Item, {
        children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
          message: errorMessage,
          type: "error",
          banner: true
        }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
          message: successMessage,
          type: "success",
          banner: true
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: "Valider l'\xE9chantillon"
        })
      })]
    })]
  });
};
export default NewSample;